import TextField from '@material-ui/core/TextField';
import styled from '@emotion/styled';

/**
 * @constant
 * @description Styled TextField component with custom theme-consistent styling.
 * Extends Material-UI TextField with application-specific focus border color
 * to maintain consistent visual design across the application.
 *
 * Key Features:
 * - Custom focus border color (#f5e0b5) matching application theme
 * - Emotion styled-components integration
 * - Material-UI TextField base functionality
 * - Consistent styling across all text inputs
 * - Theme-aware design system integration
 *
 * @type {React.Component}
 *
 * @example
 * // Used in CustomTextField component
 * import { StyledTextField } from './CustomTextField.style';
 *
 * <StyledTextField
 *   name="username"
 *   value={value}
 *   onChange={onChange}
 *   error={error}
 *   helperText={helperText}
 * />
 *
 * @see TextField - Material-UI TextField component
 * @see styled - Emotion styled function
 * @see CustomTextField - Component that uses this styled component
 */
export const StyledTextField = styled(TextField)`
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
        border-color: #f5e0b5;
    }
`;
